import * as Three from 'three';
import React from 'react';
import { lineBreakWord } from '../../../common/functions/helperFunctions';

export default {
    name: 'smokeExtractor',
    prototype: 'items',

    info: {
        tag: [''],
        title: 'Smoke extractor',
        description: 'Smoke extractor',
        image: require('./smokeExtractor.PNG')
    },

    properties: {
        altitude: {
            label: 'altitude',
            type: 'length-measure',
            defaultValue: {
                length: 0,
                unit: 'cm'
            }
        }
    },

    render2D: function (element, layer, scene) {
        let style = { stroke: element.selected ? '#000' : '#777', strokeWidth: "2px", fill: "white" };
        let width = 20;
        let depth = 80;
        let angle = element.rotation + 90;
        let textRotation = 0;
        if (Math.sin(angle * Math.PI / 180) < 0) {
            textRotation = 180;
        }
        let desc = lineBreakWord(element.desc, 20);

        return (
            <g transform={`translate(${-width / 2},${-depth / 2})`}>
                <rect key='1' x={5} width={10} height={depth + 10} style={style} />
                <rect key='2' width={width} height={depth} style={style} />
                <circle key="3" cx={10} cy={0} r={10} style={style} />
                <circle key="4" cx={10} cy={0} r={5} style={style} />
                <text key="8" x="0" y="0"
                    transform={`translate(${width / 2}, ${textRotation === 0 ? -10 : depth + 10}) scale(1,-1) rotate(${textRotation})`}
                    style={{ textAnchor: "middle", fontSize: "11px" }}>
                    {desc.map((r, index) => <tspan key={index + 'desc'} x="0" y={12 * (index + 1)}>{r}</tspan>)}
                </text>
            </g>
        )
    },


    render3D: function (element, layer, scene) {
        let mesh = new Three.Mesh();
        return Promise.resolve(mesh);
    },

    renderAxonomertic: function (element, layer, scene) {
        let style = { stroke: element.selected ? '#000' : '#777', strokeWidth: "2px", fill: "white" };
        let width = 20;
        let depth = 80;
        let angle = element.rotation + 90;
        let textRotation = 0;
        if (Math.sin(angle * Math.PI / 180) < 0) {
            textRotation = 180;
        }


        let desc = lineBreakWord(element.desc, 20);
        if (element.rotation === 0) {
            return (
                <g transform={`translate(-60,-120)`}>
                    <rect key='1' x={5} width={10} height={depth + 10} style={style} />
                    <rect key='2' width={width} height={depth} style={style} />
                    <circle key="3" cx={10} cy={0} r={10} style={style} />
                    <circle key="4" cx={10} cy={0} r={5} style={style} />
                    {element.productCount
                        ? <>
                            <path d={`M${width - 10} 20 L${width + 30} 50`} style={{ stroke: '#777', strokeWidth: '2px' }} />
                            <path d={`M${width + 30} 50 L${width + 40} 50`} style={{ stroke: '#777', strokeWidth: '2px' }} />
                            <circle id="3" cx={`${width + 50}`} cy="50" r="17" style={{ stroke: '#777', fill: '#ffffff', strokeWidth: '2px' }} />
                            <text
                                x={`${width + 50}`}
                                y="-50"
                                fontFamily="Arial"
                                alignmentBaseline="middle"
                                textAnchor="middle"
                                fontSize={24}
                                fill="#000000"
                                transform={`scale(1,-1) rotate(${textRotation})`}
                            >
                                {element.productCount}
                            </text>
                        </>
                        : <text key="8" x="0" y="0"
                            transform={`translate(${width / 2}, ${textRotation === 0 ? -10 : depth + 10}) scale(1,-1) rotate(${textRotation})`}
                            style={{ textAnchor: "middle", fontSize: "11px" }}>
                            {desc.map((r, index) => <tspan key={index + 'desc'} x="0" y={12 * (index + 1)}>{r}</tspan>)}
                        </text>}
                </g>
            )
        } else {
            let translate = 'translate(70, -30)';

            if (element.rotation > 0) {
                translate = 'translate(-70, -30)'
            }

            return (
                <g transform={`${translate}`}>
                    <rect key='1' x={5} width={10} height={depth + 10} style={style} />
                    <rect key='2' width={width} height={depth} style={style} />
                    <circle key="3" cx={10} cy={0} r={10} style={style} />
                    <circle key="4" cx={10} cy={0} r={5} style={style} />
                    {element.productCount
                        ? <>
                            <path d={`M${width - 10} 20 L${width + 30} 50`} style={{ stroke: '#777', strokeWidth: '2px' }} />
                            <path d={`M${width + 30} 50 L${width + 40} 50`} style={{ stroke: '#777', strokeWidth: '2px' }} />
                            <circle id="3" cx={`${width + 50}`} cy="50" r="17" style={{ stroke: '#777', fill: '#ffffff', strokeWidth: '2px' }} />
                            <text
                                x={`${element.rotation > -180 ? width + 50 : -1 * (width + 50)}`}
                                y={`${element.rotation > -180 ? '-50' : '50'}`}
                                fontFamily="Arial"
                                alignmentBaseline="middle"
                                textAnchor="middle"
                                fontSize={24}
                                fill="#000000"
                                transform={`scale(1,-1) rotate(${textRotation})`}
                            >
                                {element.productCount}
                            </text>
                        </>
                        : <text key="8" x="0" y="0"
                            transform={`translate(${width / 2}, ${textRotation === 0 ? -10 : depth + 10}) scale(1,-1) rotate(${textRotation})`}
                            style={{ textAnchor: "middle", fontSize: "11px" }}>
                            {desc.map((r, index) => <tspan key={index + 'desc'} x="0" y={12 * (index + 1)}>{r}</tspan>)}
                        </text>}
                </g>
            )
        }
    }
};
